import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "downloadApp"
}
const _hoisted_2 = { class: "text" }
const _hoisted_3 = { class: "h1" }
const _hoisted_4 = { class: "preamble" }
const _hoisted_5 = { class: "buttonWrapper" }
const _hoisted_6 = ["href"]
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "preview" }
const _hoisted_9 = ["src", "alt"]

import { ref } from 'vue';
import { Icon } from '../../Atoms';


export default /*@__PURE__*/_defineComponent({
  __name: 'DownloadApp',
  props: {
    title: {},
    text: {},
    imageSrc: {},
    imageAlt: {},
    downloadLink: {},
    downloadLinkText: {},
    alertLink: {},
    alertLinkText: {}
  },
  setup(__props: any) {

const showComponent = ref(true);

const closeComponent = () => {
  showComponent.value = false;
};



return (_ctx: any,_cache: any) => {
  return (showComponent.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("button", {
          class: "closeButton",
          onClick: closeComponent
        }, [
          _createVNode(_unref(Icon), { "icon-name": "close-white" })
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.title), 1),
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.text), 1),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("a", {
              href: _ctx.downloadLink,
              class: "button"
            }, _toDisplayString(_ctx.downloadLinkText), 9, _hoisted_6),
            _createElementVNode("a", {
              href: _ctx.alertLink,
              class: "button"
            }, _toDisplayString(_ctx.alertLinkText), 9, _hoisted_7)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("img", {
            src: _ctx.imageSrc,
            loading: "lazy",
            class: "backgroundImage",
            alt: _ctx.imageAlt
          }, null, 8, _hoisted_9)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})